/**
 * 開発環境によって値を変える
 * @return {String} - ユルマールの開発環境のURLを返す
 */
export default () => {
  const host = window.location.host
  switch (true) {
    // ローカル
    case /^(192.168.10.10|localhost)/.test(host):
      return 'http://192.168.10.10/'
      break
    // dev
    case /^(dev|stg|demo)/.test(host):
      return 'https://dev.ulmar.jp/'
      break
    // prd
    case /^(www|uranai.tv)/.test(host):
    default:
      return 'https://ulmar.jp/'
      break
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/getUlmarEnvDomain.js